var exports = {
  "kL": "x936d19a0--221382--container",
  "Hw": "x936d19a0--221382--mobile",
  "ZZ": "x936d19a0--221382--field",
  "tA": "x936d19a0--221382--submit",
  "B$": "x936d19a0--221382--count-down",
};

module.exports = exports;
